import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const RegionsSection = () => {
  const { t } = useTranslation();

  const regions = [
    {
      key: 'islay',
      name: 'Islay',
      subtitle: t('region_islay_subtitle'),
      description: t('region_islay_desc'),
      character: t('region_islay_char'),
      link: '/the-estate',
      linkLabel: t('region_islay_link'),
      image: 'https://readdy.ai/api/search-image?query=Islay%20Scotland%20dramatic%20coastal%20landscape%20rocky%20cliffs%20Atlantic%20ocean%20moody%20dark%20sky%20whisky%20island%20atmospheric%20cinematic%20photography%20Scottish%20island%20rugged%20beauty&width=700&height=500&seq=region-islay&orientation=landscape',
      accent: t('region_islay_accent'),
      icon: 'ri-fire-line',
    },
    {
      key: 'speyside',
      name: 'Speyside',
      subtitle: t('region_speyside_subtitle'),
      description: t('region_speyside_desc'),
      character: t('region_speyside_char'),
      link: '/speyside',
      linkLabel: t('region_speyside_link'),
      image: 'https://readdy.ai/api/search-image?query=Speyside%20Scotland%20River%20Spey%20valley%20green%20hills%20golden%20light%20whisky%20distillery%20countryside%20atmospheric%20beautiful%20landscape%20Scottish%20Highlands%20rolling%20hills&width=700&height=500&seq=region-speyside&orientation=landscape',
      accent: t('region_speyside_accent'),
      icon: 'ri-leaf-line',
    },
    {
      key: 'highlands',
      name: 'Highlands',
      subtitle: t('region_highlands_subtitle'),
      description: t('region_highlands_desc'),
      character: t('region_highlands_char'),
      link: '/descubra-as-highlands',
      linkLabel: t('region_highlands_link'),
      image: 'https://readdy.ai/api/search-image?query=Scottish%20Highlands%20dramatic%20mountain%20landscape%20misty%20peaks%20heather%20moorland%20golden%20hour%20atmospheric%20moody%20photography%20rugged%20terrain%20ancient%20Scotland%20cinematic&width=700&height=500&seq=region-highlands&orientation=landscape',
      accent: t('region_highlands_accent'),
      icon: 'ri-landscape-line',
    },
  ];

  return (
    <section className="bg-[#080808] py-24 px-6 md:px-10 xl:px-16">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-16">
          <p className="text-[#c9a84c] text-xs tracking-[0.3em] uppercase mb-4 font-medium">{t('regions_label')}</p>
          <h2
            className="text-4xl md:text-5xl font-light text-white mb-4"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            {t('regions_title')}
          </h2>
          <p className="text-white/40 text-sm font-light max-w-xl mx-auto leading-relaxed">
            {t('regions_subtitle')}
          </p>
        </div>

        <div className="flex flex-col gap-6">
          {regions.map((region, idx) => (
            <div
              key={region.key}
              className={`group grid grid-cols-1 lg:grid-cols-2 gap-0 rounded-2xl overflow-hidden border border-white/8 hover:border-[#c9a84c]/30 transition-all duration-500 ${idx % 2 === 1 ? 'lg:grid-flow-dense' : ''}`}
            >
              <div className={`relative h-64 lg:h-80 overflow-hidden ${idx % 2 === 1 ? 'lg:col-start-2' : ''}`}>
                <img
                  src={region.image}
                  alt={region.name}
                  className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
                <div className="absolute bottom-5 left-5 flex items-center gap-2 bg-black/60 backdrop-blur-sm border border-[#c9a84c]/30 rounded-full px-4 py-2">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className={`${region.icon} text-[#c9a84c] text-sm`}></i>
                  </div>
                  <span className="text-[#c9a84c] text-[10px] tracking-widest uppercase font-medium">{region.accent}</span>
                </div>
              </div>

              <div className={`bg-[#111111] p-8 md:p-12 flex flex-col justify-center ${idx % 2 === 1 ? 'lg:col-start-1 lg:row-start-1' : ''}`}>
                <p className="text-[#c9a84c]/60 text-[10px] tracking-[0.3em] uppercase mb-2 font-medium">{region.subtitle}</p>
                <h3
                  className="text-3xl md:text-4xl font-light text-white mb-4"
                  style={{ fontFamily: "'Cormorant Garamond', serif" }}
                >
                  {region.name}
                </h3>
                <p className="text-white/50 text-sm font-light leading-relaxed mb-5">
                  {region.description}
                </p>
                <div className="flex items-center gap-2 mb-8">
                  <div className="w-4 h-px bg-[#c9a84c]/40" />
                  <p className="text-[#c9a84c]/70 text-[10px] tracking-[0.2em] uppercase font-medium">{region.character}</p>
                </div>
                <div className="flex flex-wrap gap-3">
                  <Link
                    to="/whiskies"
                    className="bg-[#c9a84c] hover:bg-[#b8963e] text-black text-[10px] tracking-widest uppercase font-bold px-6 py-3 rounded-md transition-all whitespace-nowrap"
                  >
                    {t('region_see_whiskies')} {region.name}
                  </Link>
                  <Link
                    to={region.link}
                    className="border border-white/15 hover:border-[#c9a84c]/40 text-white/50 hover:text-[#c9a84c] text-[10px] tracking-widest uppercase px-6 py-3 rounded-md transition-all whitespace-nowrap"
                  >
                    {region.linkLabel}
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RegionsSection;
